(function($) {
    $(function () {
        
        let stickyOffsetTop = 0
        const $adminBar = $('#wpadminbar');
        
        if ($adminBar.length && $adminBar.css('position') === 'fixed') {
            stickyOffsetTop += $adminBar.outerHeight();
        }
        
        if ($.fn.stick_in_parent) {
            $("#asab-metric-settings .asab-settings__inner").stick_in_parent({
                parent: $(document.body),
                offset_top: stickyOffsetTop,
                sticky_class: 'is-stuck',
            })
            .on("sticky_kit:stick", function(e) {
                $(document.body).addClass('asab-settings-stuck')
            })
            .on("sticky_kit:unstick", function(e) {
                $(document.body).removeClass('asab-settings-stuck')
            });
        }
        
        $("#asab-product-cta-button").on("click", function() {
            try {
                dataLayer.push({
                    event: "interaction",
                    ec: "Buttons",
                    ea: "Click",
                    el: "ASA Benchmarks Demo Banner (General)",        
                })
            } catch(e) {
                console.log(e)
            }
        })
        
        $(".asab-popular-request").on("click", function() {
            try {
                dataLayer.push({
                    event: "interaction",
                    ec: "Buttons",
                    ea: "Click",
                    el: "ASA Benchmarks Popular Request",
                })
            } catch(e) {
                console.log(e)
            }
        })
        
    })
})(window.jQuery)
